import { memoize } from "lodash-es";
import { supportedBrowsersRegex } from "./supported-browsers-regex";
import type { BrowserInfo } from "./types";

/**
 * Detects if the current browser is supported based on AWS Console browserslist config.
 * Memoized for performance - only checks once per session.
 *
 * Pattern matches Concourse implementation.
 */
export const useBrowserDetection = memoize((): BrowserInfo => {
  const userAgent = navigator.userAgent;
  const isSupported = supportedBrowsersRegex.test(userAgent);

  return {
    isSupported,
    userAgent,
  };
});
